import React, { useState } from "react";
import { TypeStatusOperationEnum, typeStatusOperationLabels } from "./MasterDataTypes";

type StatusCheckboxListProps = {
    selectedStatuses: TypeStatusOperationEnum[];
    onChange: (statuses: TypeStatusOperationEnum[]) => void;
};

const StatusCheckboxList: React.FC<StatusCheckboxListProps> = ({ selectedStatuses, onChange }) => {
    const handleCheckboxChange = (status: TypeStatusOperationEnum) => {
        if (selectedStatuses.includes(status)) {
            onChange(selectedStatuses.filter((s) => s !== status));
        } else {
            onChange([...selectedStatuses, status]);
        }
    };

    return (
        <div style={{ display: "flex", gap: "10px" }}>
            {Object.values(TypeStatusOperationEnum).map((status) => (
                <label key={status} style={{ display: "flex", alignItems: "center" }}>
                    <input
                        type="checkbox"
                        checked={selectedStatuses.includes(status)}
                        onChange={() => handleCheckboxChange(status)}
                    />
                    <span style={{ marginLeft: "5px" }}>{typeStatusOperationLabels[status]}</span>
                </label>
            ))}
        </div>
    );
};

export default StatusCheckboxList;
